
import VLabel from '~/components/ui/VLabel'
import VRadio from '~/components/ui/VRadio'
import VButton from '~/components/ui/VButton'
import VFormGroup from '~/components/ui/VFormGroup'
import BookingTime from '~/components/booking/BookingTime'
import CoworkingBookingLayout from '~/components/modals/booking/CoworkingBookingLayout'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        console.log(this.$i18n);
        this.changeData({field: 'price', value: this.item.prices[0]})
        this.changeData({field: 'date', value: new Date().toISOString().split('T')[0]})
    },
    computed: {
        ...mapState('booking', [
            'bookingData'
        ]),
        dateString() {
            if (this.$i18n.localeProperties.code === 'ge') {
                return moment(this.bookingData.date, 'YYYY-MM-DD').toDate().toLocaleDateString(this.$i18n.localeProperties.iso)
            }
            return moment(this.bookingData.date, 'YYYY-MM-DD').toDate().toLocaleDateString(this.$i18n.localeProperties.iso, {month: "long",day: "numeric"})
        },
        currentPrice() {
            return this.item.prices.find(el => el.id === this.bookingData.price?.id)
        },
        prices() {
            return this.item.prices.map(el => {
                return {
                    ...el,
                    description: `${el.description} - ${el.formatted}`,
                    id: el.id
                }
            })
        }
    },
    methods: {
        ...mapActions('booking', [
            'changeData'
        ])
    },
    components: {
        VLabel,
        VRadio,
        VButton,
        VFormGroup,
        BookingTime,
        CoworkingBookingLayout
    }
}
